// src/screens/AuthScreen/AutoLogin.js
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LogInPopup from './LogInPopup';

const AutoLogin = () => {
  const [searchParams] = useSearchParams();
  const { verifySession, loading } = useAuth();  // Add loading from context
  const navigate = useNavigate();
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  useEffect(() => {
    const authenticate = async () => {
      const token = localStorage.getItem('token');
  
      try {
        console.log('Verifying session with token:', token);
        const isValid = token ? await verifySession(token) : false;
        
        if (isValid) {
          navigate('/', { replace: true });
        } else {
          console.log('Session is invalid, showing login popup');
          setShowLoginPopup(true);
        }
      } catch (error) {
        console.error('Authentication error:', error);
        navigate('/unauthorized');
      }
    };

    authenticate();
  }, [navigate, verifySession]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">Authenticating with ERPNext...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {showLoginPopup && <LogInPopup togglePopup={() => setShowLoginPopup(false)} />}
    </>
  );
};


export default AutoLogin;